module.exports = __webpack_public_path__ + "static/assets/d12a999338123fc4e1e65502f703efbe.png";